import React from 'react';

const DepositBonus = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9901 2.4989C14.3053 2.4989 16.2119 4.24803 16.4606 6.49688H17.9668C17.7128 3.41863 15.1339 0.999611 11.9901 0.999611C8.84634 0.999611 6.26754 3.41863 6.01351 6.49688H7.51973C7.7684 4.24803 9.67501 2.4989 11.9901 2.4989ZM2.24512 11.9951C2.24512 9.92498 3.92326 8.24684 5.99335 8.24684H19.9867C20.9528 8.24684 21.7359 9.02997 21.7359 9.99601V12.2441H21.7369V12.9938V17.9914V18.741H21.7359V20.9908C21.7359 21.9569 20.9528 22.74 19.9867 22.74H5.99335C3.92326 22.74 2.24512 21.0619 2.24512 18.9918V11.9951ZM20.2366 9.99601V12.2441H17.4889C15.6948 12.2441 14.2404 13.6985 14.2404 15.4926C14.2404 17.2866 15.6948 18.741 17.4889 18.741H20.2366V20.9908C20.2366 21.1288 20.1248 21.2407 19.9867 21.2407H5.99335C4.75129 21.2407 3.74441 20.2338 3.74441 18.9918V11.9951C3.74441 10.753 4.7513 9.74613 5.99335 9.74613H19.9867C20.1248 9.74613 20.2366 9.85801 20.2366 9.99601ZM17.4889 17.2417H20.2366V13.7434H17.4889C16.5229 13.7434 15.7397 14.5265 15.7397 15.4926C15.7397 16.4586 16.5229 17.2417 17.4889 17.2417Z",
      fill: "white"
    }
  )
);

export { DepositBonus };
//# sourceMappingURL=DepositBonus.js.map
